import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

const GuessHeadings = ({ columns }) => {
	const xs = 12 / columns.length;
	return (
		<Box sx={{ flexGrow: 1, pl: 1.5, pr: 1.5 }}>
			<Grid container spacing={0.5} alignItems="center">
				{columns.map(col => (
					<Grid item xs={xs} key={col.key}>
						<Typography variant="caption" sx={{ width: '100%', display: 'inline-block', textAlign: 'center' }}>
							{col.label}
						</Typography>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default GuessHeadings;
